import type {Table as ReactTable} from '@tanstack/react-table';
import {useTranslation} from 'react-i18next';

import {InputLabel} from '@/components/ui/input';
import {ToggleGroup, ToggleGroupItem} from '@/components/ui/toggle-group';

interface ExportResidentsPropertiesToggleProps<TData> {
  table: ReactTable<TData>;
}

function ExportResidentsPropertiesToggle<TData>({
  table,
}: ExportResidentsPropertiesToggleProps<TData>) {
  const {t} = useTranslation();

  const visibilityColumns = table
    .getAllLeafColumns()
    .filter(
      column =>
        column.getCanHide() && column.columnDef.meta?.enableExportPreviewToogle
    );

  return (
    <section className="space-y-4">
      <InputLabel asChild>
        <p>{t('Select properties to export')}</p>
      </InputLabel>
      <ToggleGroup
        type="multiple"
        itemVariant="white"
        className="flex flex-row flex-wrap gap-2"
        value={visibilityColumns.filter(c => c.getIsVisible()).map(c => c.id)}
        onValueChange={values => {
          visibilityColumns.forEach(column => {
            const visible = values.includes(column.id);
            if (visible !== column.getIsVisible()) {
              column.getToggleVisibilityHandler()({
                target: {checked: visible},
              });
            }
          });
        }}
      >
        {visibilityColumns.map(column => (
          <ToggleGroupItem key={column.id} value={column.id} size="small">
            {column.columnDef?.header?.toString() || column.id}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </section>
  );
}

export default ExportResidentsPropertiesToggle;
